export default __webpack_public_path__ + "static/campaign.url-d9c6753c3aedcf7997041714ad426095.svg";